import dashboardSummaryTemplate from './dashboardSummary.html';
var c3 = require('c3');

var has_seen_alert = false;

function genearteEvaluationDonuts(evaluations) {
    var parent = document.querySelector('#evaluations_container');
    var activityKeys = Object.keys(evaluations)
    for (var i = 0; i < activityKeys.length; i++) {
        var activity = activityKeys[i];
        var propertyKeys = Object.keys(evaluations[activity])
        for (var j = 0; j < propertyKeys.length; j++) {
            var property = propertyKeys[j];
            var valueKeys = Object.keys(evaluations[activity][property]);
            var columnsData = [];
            for (var k = 0; k < valueKeys.length; k++) {
                var value = valueKeys[k];
                var count = evaluations[activity][property][value];
                columnsData.push([ value, count ]);
            }
            var column = document.createElement('div');
            column.className = 'col-lg-3';
            var div = document.createElement('div');
            column.appendChild(div);
            parent.appendChild(column);
            c3.generate({
                bindto: div,
                data: {
                      columns: columnsData,
                    type: 'donut'
                },
                donut: {
                    title: activity + ' - ' + property
                }
            });
        }
    }
}

function genearteExerciseEvaluationGauge(percentage) {
    var chart = c3.generate({
        bindto: '#eval_rate',
        data: {
            columns: [
                ['data', percentage]
            ],
            type: 'gauge'
        },
        tooltip: {
            show: false
        },
        gauge: {
            label: {
                format: function(value, ratio) {
                    return value ? value.toFixed(1) + ' %' : value;
                },
                show: false
           },
        },
        color: {
            pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'],
            threshold: {
                values: [30, 60, 95, 100]
            }
        },
    });
}

function dashboardSummary(Restangular) {
    'use strict';

    return {
        restrict: 'E',
        scope: {},
        controller: ['$scope', function($scope) {
            $scope.stats = {};
            $scope.has_seen_alert = has_seen_alert;
            $scope.dismissAlert = () => {
                has_seen_alert = true;
                $scope.has_seen_alert = true;
            };

            Restangular.one('dashboard', 'summary')
                .get()
                .then(function(response) {
                    $scope.stats = response.data || response;
                    if ($scope.stats.eval_rate === null) {
                        $scope.stats.eval_rate = 0;
                    }
                    if ($scope.stats.eval_rate !== undefined) {
                      genearteExerciseEvaluationGauge($scope.stats.eval_rate);
                    }
                    if ($scope.stats.evaluations_by_activity !== undefined) {
                      genearteEvaluationDonuts($scope.stats.evaluations_by_activity);
                    }
                });
        }],
        template: dashboardSummaryTemplate
    };
}

dashboardSummary.$inject = ['Restangular'];

export default dashboardSummary;



// WEBPACK FOOTER //
// ./js/dashboard/dashboardSummary.js